<script setup lang="ts">
// Static chrome; no store/router dependencies.
</script>

<template>
  <footer class="app-footer" data-testid="app-footer">
    <div class="footer-content">
      <div class="footer-brand">
        <a href="https://noriagentic.com" target="_blank" rel="noopener noreferrer">
          <span class="logo-mark" aria-hidden="true">
            <svg width="24" height="24" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect x="1" y="11" width="20" height="20" rx="2" fill="#065c0e" stroke="#000" stroke-width="1.5" />
              <rect x="11" y="1" width="20" height="20" rx="2" fill="#065c0e" stroke="#000" stroke-width="1.5" />
            </svg>
          </span>
          <span>Nori Skillsets</span>
        </a>
      </div>

      <div class="footer-links">
        <div class="footer-col">
          <h4>Product</h4>
          <a href="https://noriskillsets.dev/" target="_blank" rel="noopener noreferrer">Skillsets</a>
          <a href="https://github.com/tilework-tech/nori-cli" target="_blank" rel="noopener noreferrer">CLI</a>
        </div>
        <div class="footer-col">
          <h4>Community</h4>
          <a href="https://github.com/tilework-tech" target="_blank" rel="noopener noreferrer">GitHub</a>
        </div>
        <div class="footer-col">
          <h4>Contact</h4>
          <a href="mailto:contact@tilework.tech">Email</a>
        </div>
      </div>
    </div>
  </footer>
</template>

<style scoped>
.app-footer {
  border-top: 1px solid var(--border);
  padding: 3rem 2rem 2rem;
  margin-top: auto;
}

.footer-content {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  gap: 2rem;
}

.footer-brand a {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  font-family: var(--font-display);
  font-weight: 600;
}

.footer-links {
  display: flex;
  gap: 3rem;
}

.footer-col {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.footer-col h4 {
  font-size: 0.8125rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: var(--muted-foreground);
  margin: 0 0 0.25rem;
}

.footer-col a {
  font-size: 0.875rem;
  color: var(--muted-foreground);
}

.footer-col a:hover {
  color: var(--foreground);
}

@media (max-width: 768px) {
  .footer-content {
    flex-direction: column;
  }
}
</style>
